// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatInputView-module__wrapper--c7b6b","input":"ChatInputView-module__input--a49a8","button":"ChatInputView-module__button--eee1b"};